export type BaasHierarchicalActionConfig = {
    navigate: boolean;
    edit: boolean;
    move: boolean;
    delete: boolean;
    create: boolean;
    view: boolean;
};

export function createDefaultBaasHierarchicalActionConfig(): BaasHierarchicalActionConfig {
    return {
        navigate: true,
        edit: true,
        move: true,
        delete: true,
        create: true,
        view: true
    };
}
